<template>
  <p class="timer__output">
    <template v-if="timeBeforeWalking">
      До следующей прогулки осталось: {{ timeBeforeWalking }}
    </template>
    <template v-else> Длительность прогулки: {{ timeWalking }} </template>
  </p>
</template>

<script lang="ts">
import { defineComponent, Component, onMounted, ref } from "vue";

export function setupTimer() {
  let timeStart: Date
  const lsTimeStart: string | null = localStorage.getItem("timeStart"); // Время старта последней прогулки

  if (lsTimeStart) {
    timeStart = new Date(lsTimeStart);
  } else {
    timeStart = new Date();
    localStorage.setItem("timeStart", timeStart.toString());
  }

  const timeWalking = ref(""); // Время прогулки (для отображения)
  const timeBeforeWalking = ref(""); // Время до следующей прогулки (для отображения)
  const t1year = 31536000000;
  const t3hour = 10800000;
  const t1day = 86400000;
  const t1hour = 3600000;
  const t1min = 60000;

  const canWalk = (): boolean => {
    const ms: number = Date.now() - timeStart.getTime();
    return !(ms > t3hour && ms < t1year);
  };

  onMounted(() => {
    const setTime = function() {
      const timer: HTMLInputElement | null = document.querySelector(
        ".timer__output"
      );
      if (timer) {
        const ms: number = Date.now() - timeStart.getTime();

        if (canWalk()) {
          const h: number = Math.floor(ms / t1hour);
          const m: number = Math.floor((ms - h * t1hour) / t1min);
          timeWalking.value = `${h > 0 ? h.toString() + "ч. и" : ""} ${m} мин.`;
        } else {
          // Ставим блокировку
          const d: number = Math.floor((t1year - ms) / t1day);
          const h: number = Math.floor((t1year - ms - d * t1day) / t1hour);
          const m: number = Math.floor(
            (t1year - ms - h * t1hour - d * t1day) / t1min
          );
          timeBeforeWalking.value = `${d > 0 ? d.toString() + "сут.," : ""} ${
            h > 0 ? h.toString() + "ч. и" : ""
          } ${m} мин.`;
        }
      } else {
        throw new Error(".timer__output not exist ");
      }
    };

    setTime();
    setInterval(setTime, 1000);
  });

  return {
    timeStart,
    timeWalking,
    timeBeforeWalking,
    canWalk,
    t3hour
  };
}

const Timer: Component = defineComponent({
  name: "Timer",
  setup: setupTimer
});

export default Timer;
</script>

<style scoped>
.timer__output {
  color: grey;
  font-size: 12px;
  font-style: italic;
  font-weight: normal;
  text-shadow: 1px 1px 2px #d9d9d9;
}
</style>
